import { render } from "./ButtonTestEmails.vue?vue&type=template&id=57fe2b72"
import script from "./ButtonTestEmails.vue?vue&type=script&lang=js"
export * from "./ButtonTestEmails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__